import moment from 'moment';

export const toDateString = (moment) => moment.format('ll');

export const isSessionEndDateOrAfter = (endDate) =>
  moment(endDate).isSameOrAfter(moment(), 'day');
